var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background-primary-color crossed d-flex justify-center mb-8 position-relative"},[_c('status-delivering',{attrs:{"is-crossed":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }